module.exports = __webpack_public_path__ + "img/list2.a5210fd5.png";